import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import RegisterPage from './pages/RegisterPage';
import ReviewPage from './pages/ReviewPage';
import SettingsPage from './pages/SettingsPage';
import ChatPage from './pages/ChatPage';
import DataSync from './pages/DataSync';
import UserManagementPage from './pages/UserManagementPage';
import MyProfilePage from './pages/MyProfilePage';
import RagAgent from './pages/RagAgentPage';
import Layout from './components/Layout';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route
                    path="/review"
                    element={
                        <Layout>
                            <ReviewPage />
                        </Layout>
                    }
                />
                <Route
                    path="/dashboard"
                    element={
                        <Layout>
                            <DashboardPage />
                        </Layout>
                    }
                />
                <Route
                    path="/settings"
                    element={
                        <Layout>
                            <SettingsPage />
                        </Layout>
                    }
                />
                <Route
                    path="/conversation"
                    element={
                        <Layout>
                            <ChatPage />
                        </Layout>
                    }
                />
                <Route
                    path="/data_sync"
                    element={
                        <Layout>
                            <DataSync />
                        </Layout>
                    }
                />                
                <Route
                    path="/rag_agent"
                    element={
                        <Layout>
                            <RagAgent />
                        </Layout>
                    }
                />
                <Route
                    path="/user_management"
                    element={
                        <Layout>
                            <UserManagementPage />
                        </Layout>
                    }
                />
                <Route
                    path="/my_profile"
                    element={
                        <Layout>
                            <MyProfilePage />
                        </Layout>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;